/**
 * index.js - o catalogo de mapas.
 *
 * O menu le a lista daqui e o Level pergunta a este modulo o que construir. Sao
 * DOIS caminhos diferentes, de proposito:
 *
 *   'setor7'  o quarteirao que mora dentro do src/world/Level.js. NAO tem modulo
 *             proprio e nao pode ganhar um: o codigo dele e o caminho original
 *             do jogo, intocado. Aqui ele so e ANUNCIADO na lista, e todas as
 *             funcoes de construcao devolvem false/null para o Level seguir
 *             usando o metodo interno dele.
 *   os demais modulos de src/world/maps/, que constroem a geometria com os
 *             ajudantes que o proprio Level expoe na instancia (_slab, _floor,
 *             _building, _place, batch, mats...).
 *
 * Nenhuma funcao daqui engole excecao. Se um modulo de mapa quebrar durante o
 * build, o erro TEM que subir: devolver false depois de ja ter empurrado
 * geometria no batcher faria o Level montar o setor 7 por cima do mapa
 * quebrado, e o defeito apareceria como cenario embaralhado em vez de erro.
 */

import * as porto from './porto.js';
import * as deposito from './deposito.js';
import * as vila from './vila.js';

/** Identificador do mapa interno do Level. */
export const BUILTIN_ID = 'setor7';

/**
 * A ficha do mapa interno. Nao tem `bounds` porque quem manda nos limites do
 * setor 7 e o proprio Level - duas verdades para a mesma caixa e o comeco de
 * uma divergir da outra.
 */
const BUILTIN = {
  id: BUILTIN_ID,
  name: 'SETOR 7',
  sub: 'QUARTEIR\u00c3O AL-NASR',
  ambiente: 'tarde'
};

/** Ordem do menu: o mapa de origem primeiro, os novos na ordem em que nasceram. */
const MODULES = [porto, deposito, vila];

const BY_ID = new Map();
for (let i = 0; i < MODULES.length; i++) {
  const m = MODULES[i];
  BY_ID.set(m.meta.id, m);
}

/** O que o menu e o lobby mostram. Sempre com o setor 7 na frente. */
export const MAPS = [{ id: BUILTIN.id, name: BUILTIN.name, sub: BUILTIN.sub }].concat(
  MODULES.map((m) => ({ id: m.meta.id, name: m.meta.name, sub: m.meta.sub }))
);

/** Ficha do mapa (meta do modulo), ou null se o id nao existir. */
export function getMap(id) {
  const key = String(id);
  if (key === BUILTIN_ID) return BUILTIN;
  const m = BY_ID.get(key);
  return m ? m.meta : null;
}

/**
 * Constroi o mapa no `level` recebido. Devolve false para o setor 7 e para id
 * desconhecido - e esse false que faz o Level cair no caminho interno dele.
 */
export function buildMap(id, level) {
  const key = String(id);
  if (key === BUILTIN_ID) return false;
  const m = BY_ID.get(key);
  if (!m) return false;
  return m.build(level) !== false;
}

/** { player: [Vector3...], enemy: [...] } do mapa, ou null se ele nao tiver. */
export function mapSpawnPoints(id, level) {
  const key = String(id);
  if (key === BUILTIN_ID) return null;
  const m = BY_ID.get(key);
  if (!m || typeof m.spawnPoints !== 'function') return null;
  return m.spawnPoints(level);
}

/** [{ name, pos, yaw, pitch }] do mapa, ou null se ele nao tiver. */
export function mapViewpoints(id, level) {
  const key = String(id);
  if (key === BUILTIN_ID) return null;
  const m = BY_ID.get(key);
  if (!m || typeof m.viewpoints !== 'function') return null;
  return m.viewpoints(level);
}
